import React from 'react'
import BrandsProvider from './brands-provider'

export default function withBrands(WrappedComponent) {
  return function BrandsProviderHOC(props) {
    return (
      <BrandsProvider {...props}>
        <WrappedComponent {...props} />
      </BrandsProvider>
    )
  }
};
